const translations = {
    fr: {
      title: "Modifier le mot de passe",
      success: "Mot de passe mis à jour avec succès.",
      invalidOrExpired: "Demande invalide ou expirée.",
      errorGeneric: "Une erreur s'est produite.",
      errorReset: "Erreur lors de la réinitialisation du mot de passe."
    },
    en: {
      title: "Change password",
      success: "Password updated successfully.",
      invalidOrExpired: "Invalid or expired request.",
      errorGeneric: "An error occurred.",
      errorReset: "Error while resetting the password.",
    },
    de: {
      title: "Passwort ändern",
      success: "Passwort erfolgreich aktualisiert.",
      invalidOrExpired: "Ungültige oder abgelaufene Anfrage.",
      errorGeneric: "Es ist ein Fehler aufgetreten.",
      errorReset: "Fehler beim Zurücksetzen des Passworts.",
    },
    es: {
      title: "Cambiar la contraseña",
      success: "Contraseña actualizada correctamente.",
      invalidOrExpired: "Solicitud inválida o caducada.",
      errorGeneric: "Se ha producido un error.",
      errorReset: "Error al restablecer la contraseña.",
    },
    it: {
      title: "Modifica la password",
      success: "Password aggiornata con successo.",
      invalidOrExpired: "Richiesta non valida o scaduta.",
      errorGeneric: "Si è verificato un errore.",
      errorReset: "Errore durante il reset della password.",
    }
  };
  
  export default translations;
  